/* eslint-disable @typescript-eslint/no-shadow */
import cookie from 'react-cookies';

// import { getClientRegion } from '@/lib/env.client';
import { EGlobalCookieKey } from '@/types/cookie';
import type {
  CountryCodeInfo,
  ILoginRequest,
  ILoginResponse,
  IProfileUserDetail,
  IProfileUserUpdateUserDetail,
  IRegsiterRequest,
  ISmsLoginRequest,
  IThridPartRegsiterAndLoginRequest,
  IUserMindProfile,
  LoginResponse,
  NewRegisterInfo,
  PhoneDetail
} from '@/types/login';
import type { CommonResponse, EmptyResponse } from '@/types/responseModel';
import { firebaseSignOut } from '@/utils/firebase';
import { Request } from '@/utils/request';

export function loginThirdPart(data: IThridPartRegsiterAndLoginRequest) {
  const searchParams = new URLSearchParams(window.location.search);

  const browserLang = navigator.language || navigator.languages[0];
  const langParam = browserLang.startsWith('zh') ? 'zh' : undefined;

  const _inviteCode = localStorage.getItem('inviteCode');
  const _circleId = localStorage.getItem('circleId');
  const _homepageUserId = localStorage.getItem('homepageUserId');
  const _snapId = localStorage.getItem('snapId');
  const _snapInviteCode = localStorage.getItem('snapInviteCode');
  const _talkId = localStorage.getItem('talkId');
  const _talkOutputMode = localStorage.getItem('talkOutputMode');
  const _talkInviteCode = localStorage.getItem('talkInviteCode');

  return Request<CommonResponse<LoginResponse>>({
    url: '/rest/os/merchant/firebase/register/or/login',
    method: 'post',
    data: {
      ...data,
      app: 'Mebot',
      utm: {
        ...(searchParams.get('utm_source')
          ? { utm_source: searchParams.get('utm_source') || undefined }
          : {}),
        ...(searchParams.get('utm_medium')
          ? { utm_medium: searchParams.get('utm_medium') || undefined }
          : {}),
        ...(searchParams.get('utm_campaign')
          ? { utm_campaign: searchParams.get('utm_campaign') || undefined }
          : {}),
        ...(_inviteCode ? { utm_campaign: 'invite', utm_source: _inviteCode } : {}),
        ...(_snapId ? { utm_campaign: 'snap', utm_source: _snapId } : {}),
        ...(_snapInviteCode ? { utm_campaign: 'snapInvite', utm_source: _snapInviteCode } : {}),
        ...(_talkId
          ? { utm_campaign: 'talk', utm_source: _talkId, utm_medium: _talkOutputMode }
          : {}),
        ...(_talkInviteCode ? { utm_campaign: 'talkInvite', utm_source: _talkInviteCode } : {}),
        ...(_circleId ? { utm_campaign: 'circle', utm_source: _circleId } : {}),
        ...(_homepageUserId ? { utm_campaign: 'homepage', utm_source: _homepageUserId } : {})
      }
    },
    headers: {
      ...(langParam ? { lang: langParam } : {})
    }
  });
}

export function login(data: ILoginRequest) {
  const searchParams = new URLSearchParams(window.location.search);

  const browserLang = navigator.language || navigator.languages[0];
  const langParam = browserLang.startsWith('zh') ? 'zh' : undefined;

  const _inviteCode = localStorage.getItem('inviteCode');
  const _circleId = localStorage.getItem('circleId');
  const _homepageUserId = localStorage.getItem('homepageUserId');
  const _snapId = localStorage.getItem('snapId');
  const _snapInviteCode = localStorage.getItem('snapInviteCode');
  const _talkId = localStorage.getItem('talkId');
  const _talkOutputMode = localStorage.getItem('talkOutputMode');
  const _talkInviteCode = localStorage.getItem('talkInviteCode');

  return Request<ILoginResponse>({
    url: '/rest/os/merchant/firebase/register/or/login',
    method: 'post',
    data: {
      ...data,
      app: 'Mebot',
      utm: {
        ...(searchParams.get('utm_source')
          ? { utm_source: searchParams.get('utm_source') || undefined }
          : {}),
        ...(searchParams.get('utm_medium')
          ? { utm_medium: searchParams.get('utm_medium') || undefined }
          : {}),
        ...(searchParams.get('utm_campaign')
          ? { utm_campaign: searchParams.get('utm_campaign') || undefined }
          : {}),
        ...(_inviteCode ? { utm_campaign: 'invite', utm_source: _inviteCode } : {}),
        ...(_snapId ? { utm_campaign: 'snap', utm_source: _snapId } : {}),
        ...(_snapInviteCode ? { utm_campaign: 'snapInvite', utm_source: _snapInviteCode } : {}),
        ...(_talkId
          ? { utm_campaign: 'talk', utm_source: _talkId, utm_medium: _talkOutputMode }
          : {}),
        ...(_talkInviteCode ? { utm_campaign: 'talkInvite', utm_source: _talkInviteCode } : {}),
        ...(_circleId ? { utm_campaign: 'circle', utm_source: _circleId } : {}),
        ...(_homepageUserId ? { utm_campaign: 'homepage', utm_source: _homepageUserId } : {})
      }
    },
    headers: {
      ...(langParam ? { lang: langParam } : {})
    }
  });
}

export function logout() {
  return new Promise<void>((resolve, reject) => {
    const token = cookie.load(EGlobalCookieKey.token); // 测试环境

    Request<EmptyResponse>({
      url: '/rest/os/identity/logout',
      method: 'post',
      data: {
        token
      }
    })
      .then((res) => {
        if (res.data.code === 0) {
          firebaseSignOut();
          resolve();
        } else {
          reject('Log out failed');
        }
      })
      .catch(() => {
        reject('Log out failed');
      });
  });
}

export function register(data: IRegsiterRequest) {
  return Request<EmptyResponse>({
    url: '/rest/os/merchant/code/register',
    method: 'post',
    data: data
  });
}

export function userDetail() {
  return Request<CommonResponse<IProfileUserDetail>>({
    url: '/rest/os/operator/profile/query',
    method: 'get'
  });
}

export function getUserMindProfile() {
  return Request<CommonResponse<IUserMindProfile>>({
    url: '/rest/os/mind/profile',
    method: 'get'
  });
}

export function updateUserProfile(userDetail: IProfileUserUpdateUserDetail) {
  return Request<EmptyResponse>({
    url: '/rest/os/operator/profile/update',
    method: 'post',
    data: userDetail
  });
}

export function updateUserAppearance(data: { appearance: string }) {
  return Request<EmptyResponse>({
    url: '/rest/os/operator/profile/update/appearance',
    method: 'post',
    data: data
  });
}

export function checkNewRegisterInfo() {
  return Request<CommonResponse<NewRegisterInfo>>({
    url: '/rest/os/merchant/base/info/acquire',
    method: 'get'
  });
}

export function getCountryCode() {
  return Request<CommonResponse<CountryCodeInfo[]>>({
    url: '/rest/os/merchant/sms/query/country/code',
    method: 'post'
  });
}
export function smsSend(phoneDetail: PhoneDetail) {
  return Request<EmptyResponse>({
    url: '/rest/os/merchant/sms/send',
    method: 'post',
    data: phoneDetail
  });
}
export function smsLogin(data: ISmsLoginRequest) {
  const searchParams = new URLSearchParams(window.location.search);

  const browserLang = navigator.language || navigator.languages[0];
  const langParam = browserLang.startsWith('zh') ? 'zh' : undefined;

  const _inviteCode = localStorage.getItem('inviteCode');
  const _circleId = localStorage.getItem('circleId');
  const _homepageUserId = localStorage.getItem('homepageUserId');
  const _snapId = localStorage.getItem('snapId');
  const _snapInviteCode = localStorage.getItem('snapInviteCode');
  const _talkId = localStorage.getItem('talkId');
  const _talkOutputMode = localStorage.getItem('talkOutputMode');
  const _talkInviteCode = localStorage.getItem('talkInviteCode');

  return Request<CommonResponse<LoginResponse>>({
    url: '/rest/os/merchant/sms/register/or/login',
    method: 'post',
    data: {
      ...data,
      app: 'Mebot',
      utm: {
        ...(searchParams.get('utm_source')
          ? { utm_source: searchParams.get('utm_source') || undefined }
          : {}),
        ...(searchParams.get('utm_medium')
          ? { utm_medium: searchParams.get('utm_medium') || undefined }
          : {}),
        ...(searchParams.get('utm_campaign')
          ? { utm_campaign: searchParams.get('utm_campaign') || undefined }
          : {}),
        ...(_inviteCode ? { utm_campaign: 'invite', utm_source: _inviteCode } : {}),
        ...(_snapId ? { utm_campaign: 'snap', utm_source: _snapId } : {}),
        ...(_snapInviteCode ? { utm_campaign: 'snapInvite', utm_source: _snapInviteCode } : {}),
        ...(_talkId
          ? { utm_campaign: 'talk', utm_source: _talkId, utm_medium: _talkOutputMode }
          : {}),
        ...(_talkInviteCode ? { utm_campaign: 'talkInvite', utm_source: _talkInviteCode } : {}),
        ...(_circleId ? { utm_campaign: 'circle', utm_source: _circleId } : {}),
        ...(_homepageUserId ? { utm_campaign: 'homepage', utm_source: _homepageUserId } : {})
      }
    },
    headers: {
      ...(langParam ? { lang: langParam } : {})
    }
  });
}

export function initPA() {
  return Request<CommonResponse<void>>({
    url: '/rest/os/mind/template/init/pa',
    method: 'post',
    data: { mindName: '' }
  });
}
